/// <amd-module name="Wit/Common/WorkItemDialogs/Components/ConfirmationDialog" />

import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";

export interface IConfirmationDialogProps {
    title: string;
    message: string;
    primaryButtonText: string;
    onConfirm: () => void;
    onDismiss: () => void;
}

const primaryButtonClass = "ok-button";

export function ConfirmButtonDialog({ title, message, primaryButtonText, onConfirm, onDismiss }: IConfirmationDialogProps) {
    return (
        <Dialog
            showCloseButton={true}
            titleProps={{ text: title }}
            lightDismiss={false}
            onDismiss={onDismiss}
            footerButtonProps={[
                {
                    primary: true,
                    className: primaryButtonClass,
                    onClick: onConfirm,
                    text: primaryButtonText
                }
            ]}
        >
            {message}
        </Dialog>
    );
}

export function showConfirmationDialog(
    pageContext: IVssPageContext,
    message: string,
    primaryButtonText: string,
    title: string,
    onConfirmProp?: () => void
) {
    const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    layoutManager.renderCallout(onDismiss => {
        const onConfirm = () => {
            onConfirmProp && onConfirmProp();
            onDismiss();
        };
        return ConfirmButtonDialog({ title, message, primaryButtonText, onConfirm, onDismiss });
    });
}
